import React from 'react';

import css from './index.css';

const AccountHeader = (props) => (
  <div className={css.header}>
    {props.tit && <h2 className={css.title}>{props.tit}</h2>}
    {props.titleInfo && <p className={css.titleInfo}>{props.titleInfo}</p>}
  </div>
);

export default AccountHeader;



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/AccountHeader/index.js